import React, { forwardRef, useState } from "react";
import { Grid2 } from "@mui/material";
import { useSetState } from "Utils/Helpers/Hooks";
import Inputer from "Utils/Helpers/Inputer";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import * as Icons from "react-bootstrap-icons";
import MButton from "Utils/Helpers/MButton";
import Tooltip from "@mui/material/Tooltip";
import { useDispatch } from "react-redux";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { enqueueSnackbar } from "notistack";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setUsersData } from "../../../../../Redux/slices/mngrSlice";
import { post_user } from "http/components/User";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function UsersAdd() {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [controls, setControls] = useSetState({
    name: {
      display: true,
      label: "Name",
      type: "text",
      multiLine: false,
      placeholder: "Name",
      value: "",
      validation: false,
    },
    username: {
      display: true,
      label: "Username",
      type: "text",
      multiLine: false,
      placeholder: "Username",
      value: "",
      validation: false,
    },
    password: {
      display: true,
      label: "Password",
      type: "password",
      multiLine: false,
      placeholder: "Password",
      value: "",
      validation: false,
    },
  });

  const setShowDialog = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const onEnter = () => {
    onClear();
  };

  const onClear = () => {
    setControls({ name: { value: "", validation: false } });
    setControls({ username: { value: "", validation: false } });
    setControls({ password: { value: "", validation: false } });
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value, validation } });
  };

  const onSubmit = async () => {
    const { name, username, password } = controls;
    if (name.validation && username.validation && password.validation) {
      dispatch(HandleLoading(true));
      const response = await post_user({
        name: name.value,
        username: username.value,
        password: password.value,
      });
      if (CheckApiStatus(response)) {
        handleClose();
        dispatch(setUsersData(true));
        enqueueSnackbar("Insert Success", { variant: "success" });
      }
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar("Enter data correctly", { variant: "error" });
    }
  };

  return (
    <>
      <div onClick={setShowDialog} className="btn-manager btn-primary">
        <Tooltip title={"Create user"}>
          <Icons.PersonFillAdd size={25} />
        </Tooltip>
      </div>
      {show && (
        <Dialog
          open={show}
          TransitionComponent={Transition}
          TransitionProps={{ onEnter: onEnter }}
          keepMounted
          fullWidth={true}
          maxWidth={"xs"}
          onClose={handleClose}
          aria-describedby="alert-dialog-delete"
        >
          <DialogTitle>{`Create user`}</DialogTitle>
          <DialogContent className="p-0">
            {show && (
              <Grid2 container spacing={2}>
                {Object.keys(controls).map((key, index) => {
                  return (
                    <Grid2 size={{ xs: 12 }} key={key + index}>
                      {["text", "password"].includes(controls[key].type) && (
                        <Inputer
                          id={key}
                          setValue={setValue.bind(this)}
                          value={controls[key].value}
                          label={controls[key].label}
                          placeholder={controls[key].placeholder}
                          type={controls[key].type}
                          multiLine={controls[key].multiLine}
                        />
                      )}
                    </Grid2>
                  );
                })}
              </Grid2>
            )}
          </DialogContent>
          <DialogActions>
            <MButton
              label={"Close"}
              color="secondary"
              onClick={handleClose}
              className="flex-grow-1"
            />
            <MButton
              label={"Save"}
              color="primary"
              onClick={onSubmit}
              className="flex-grow-1"
            />
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
